<template>
  <resource-create-wrapper
    :title="$t('resources.phone_numbers.new_phone_number')"
    :need-modal="showModal"
    @saveAction="$refs['phoneNumberForm'].submit()">
    <v-card class="spacing-bottom--24">
      <v-card-title class="spacing-bottom--16">{{ $t("resources.phone_numbers.create.source") }}</v-card-title>
      <v-btn-toggle class="va-btn-toggle" v-model="provider" mandatory tile color="primary" group>
        <v-btn v-for="(label, value) in PHONE_NUMBER_PROVIDER_LABELS" :key="value" :value="value">
          {{ label }}
        </v-btn>
      </v-btn-toggle>
    </v-card>

    <CallsRunnerPhoneNumberForm
      v-if="provider === PHONE_NUMBER_PROVIDERS.CALLSRUNNER"
      ref="phoneNumberForm"
      @isDirtyForm="isDirtyForm"
      @finishedSaving="finishedSaving"></CallsRunnerPhoneNumberForm>
    <PhoneNumberForm
      v-else
      :phoneNumber="item"
      @isDirtyForm="isDirtyForm"
      ref="phoneNumberForm"
      @finishedSaving="finishedSaving"></PhoneNumberForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import PhoneNumberForm from "@/components/forms/PhoneNumberForm";
  import CallsRunnerPhoneNumberForm from "@/components/forms/CallsRunnerPhoneNumberForm";
  import { PHONE_NUMBER_PROVIDERS, PHONE_NUMBER_PROVIDER_LABELS } from "@/constant";

  export default {
    components: {
      ResourceCreateWrapper,
      PhoneNumberForm,
      CallsRunnerPhoneNumberForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
        provider: PHONE_NUMBER_PROVIDERS.CALLSRUNNER,
        PHONE_NUMBER_PROVIDERS,
        PHONE_NUMBER_PROVIDER_LABELS,
      };
    },
    watch: {
      // Switching providers discards the form being filled in, so the unsaved changes guard is released with it.
      provider() {
        this.isDirtyForm(false);
      },
    },
    methods: {
      save() {
        this.saveLoading = true;
        this.showModal = false;
        this.$refs["phoneNumberForm"].submit();
      },
      finishedSaving() {
        this.saveLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";

  .va-btn-toggle {
    border-radius: 4px;

    .v-btn {
      margin: 0;
      box-shadow: none !important;
      border: 1px solid get-color("secondary-btn");
      color: get-color("secondary-btn");
    }
  }
</style>
